var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTennisAustraliaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 76,
    viewBox: "0 0 115 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1214 53.7008C87.8808 53.3518 89.2795 51.8871 89.2546 49.6714C89.0694 30.3553 85.3411 0.884303 68.6566 0.503443C48.6679 0.0471591 14.9726 45.0827 11.9462 49.6513C10.8262 51.342 10.9043 52.6971 11.8622 53.4057C12.8968 54.171 14.3005 53.7795 15.848 52.0039C22.4352 44.4456 50.6649 8.34715 65.6778 9.43817C80.5492 10.5189 81.8094 45.0182 81.802 49.853C81.7993 51.6222 82.8425 54.2187 86.1214 53.7008Z",
    fill: "url(#paint0_linear_5407_67951)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5387 32.9344C18.1982 32.6784 57.0422 33.5652 82.3745 52.7567C85.3283 54.9945 89.2972 53.3912 89.2554 49.6721C89.2554 46.7231 84.8022 44.7783 81.357 42.7718C56.2326 28.1386 13.3616 26.5203 3.38729 28.8398C1.85257 29.1967 0 29.7799 0 31.1535C0 32.9313 2.20818 32.9781 4.5387 32.9344Z",
    fill: "url(#paint1_linear_5407_67951)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38729 28.8388C1.85257 29.1957 0 29.7789 0 31.1526C0 32.9304 2.20819 32.9772 4.5387 32.9335C16.6613 32.7062 32.6769 25.8021 104.388 30.8829C109.848 31.2697 113.949 28.4068 114.072 23.3879C114.196 18.3586 110.486 14.6705 104.936 14.792C76.3326 15.418 43.2789 19.2769 3.38729 28.8388Z",
    fill: "url(#paint2_linear_5407_67951)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4207 58.2596V60.3149H44.5955C45.5085 59.4559 46.5234 58.827 47.6409 58.4283C48.7578 58.0295 50.0351 57.8301 51.473 57.8301C53.6295 57.8301 55.3389 58.3669 56.602 59.4406C57.8647 60.5143 58.4963 62.1353 58.4963 64.3027V74.8246H51.9102V66.281C51.9102 64.1542 50.8123 63.0906 48.6171 63.0906C47.4902 63.0906 46.5285 63.408 45.7321 64.0417C44.9352 64.6758 44.5372 65.7394 44.5372 67.2319V74.8246H37.9512V58.2596H44.4207Z",
    fill: "#0A6DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6473 58.2596V60.3149H67.8221C68.7351 59.4559 69.75 58.827 70.8674 58.4283C71.9844 58.0295 73.2616 57.8301 74.6996 57.8301C76.8561 57.8301 78.5655 58.3669 79.8286 59.4406C81.0912 60.5143 81.7228 62.1353 81.7228 64.3027V74.8246H75.1367V66.281C75.1367 64.1542 74.0389 63.0906 71.8437 63.0906C70.7167 63.0906 69.755 63.408 68.9586 64.0417C68.1618 64.6758 67.7638 65.7394 67.7638 67.2319V74.8246H61.1777V58.2596H67.6473Z",
    fill: "#0A6DFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9884 74.8248H84.4023V58.2598H90.9884V74.8248Z",
    fill: "#0A6DFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.312 68.119C96.5682 67.5976 93.2338 66.7129 93.2338 63.1071C93.2338 58.7923 98.246 57.5547 103.113 57.5547C106.338 57.5547 108.869 57.9793 110.704 58.8277C112.54 59.6766 113.507 61.113 113.604 63.1377H106.581C106.523 62.5654 106.192 62.1613 105.59 61.926C104.988 61.6912 104.142 61.5732 103.055 61.5732C102.103 61.5732 100.286 61.773 100.286 62.7329C100.286 64.1771 102.841 64.0129 106.426 64.4442C110.011 64.8754 114.216 65.9105 114.216 69.7638C114.216 75.114 107.186 75.5002 103.492 75.5002C101.219 75.5002 99.3195 75.3362 97.7946 75.0093C96.2692 74.6825 95.0648 74.0891 94.181 73.2302C93.2967 72.3712 92.8259 71.1547 92.7676 69.5797H100.024C100.082 70.2751 100.378 70.7559 100.913 71.0215C101.447 71.2874 102.355 71.4203 103.638 71.4203C104.989 71.4203 106.905 71.2115 106.905 70.2082C106.905 68.6989 104.056 68.6404 100.312 68.119Z",
    fill: "#0A6DFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.154 66.5519C36.154 63.6718 35.2371 61.4555 33.4033 59.9029C31.5695 58.3509 28.8187 57.5742 25.1511 57.5742C21.4639 57.5742 18.7037 58.3509 16.8699 59.9029C15.036 61.4555 14.1191 63.6718 14.1191 66.5519C14.1191 69.4322 15.036 71.6434 16.8699 73.1856C18.7037 74.7281 21.4639 75.4989 25.1511 75.4989C29.0125 75.4989 31.7487 74.9473 33.3596 73.8444C34.8855 72.7993 35.7308 71.4971 35.8983 69.9385H28.8093C28.235 71.003 27.0168 71.7353 25.1511 71.7353C23.8704 71.7353 22.8902 71.4506 22.2112 70.881C21.5317 70.3114 21.1242 69.2383 20.9887 68.1759H36.0667C36.1249 67.7062 36.154 67.1648 36.154 66.5519ZM21.1342 64.4599C21.3671 63.4736 21.8132 62.66 22.4732 62.1676C23.1327 61.6758 24.0254 61.4293 25.1511 61.4293C26.2763 61.4293 27.1641 61.6758 27.8145 62.1676C28.4644 62.66 28.9061 63.4736 29.1389 64.4599H21.1342Z",
    fill: "#0A6DFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 69.6069C10.2775 69.7995 9.17969 69.4193 9.17969 67.2926V62.2479H13.2304V58.2601H9.17969V53.7812H2.5936V58.2601H0V62.2479H2.5936V68.5385C2.5936 70.7059 3.22518 72.327 4.48791 73.4006C5.75099 74.4743 7.46034 75.0112 9.6169 75.0112C11.0501 75.0112 12.3233 74.8126 13.4377 74.4164L13.022 69.5344C12.843 69.5646 12.661 69.5904 12.4727 69.6069Z",
    fill: "#0A6DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5407_67951",
    x1: 11.125,
    y1: 27.1388,
    x2: 89.2549,
    y2: 27.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.294443,
    stopColor: "#1ACF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707845,
    stopColor: "#2AD504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83206,
    stopColor: "#31D800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5407_67951",
    x1: 0,
    y1: 40.8783,
    x2: 89.2558,
    y2: 40.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.450063,
    stopColor: "#63E906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946567,
    stopColor: "#31D800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5407_67951",
    x1: 1.03709e-7,
    y1: 23.8658,
    x2: 114.075,
    y2: 23.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399873,
    stopColor: "#63E906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#AFF500"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisAustraliaLogo);
export default ForwardRef;